module.exports = __webpack_public_path__ + "img/sp-1.27b29aae.png";